<template>
  <button
  >
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "GuestButton",
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
button {
  display: grid;
  place-items: center;
  width: 45px !important;
  height: 40px;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  background: none;
  border: none;
  padding: 0;
  text-shadow: 0px 1px 18px rgba(255, 255, 255, 0.80);
  user-select: none;
  cursor: pointer;
  &.selected span {
    background: linear-gradient(180deg, #4B92DB 0%, #4B92DB 100%);
  } 
  span {
    transition: 0.2s all ease-in-out;
    width: 40px;
    height: 20px;
    display: grid;
    place-items: center;
    background: rgba(#4B92DB, 0.2);
    padding: 5px;
    color: var(--white);
    line-height: 1rem;
  }
   @media (hover: hover) {
    &:hover {
      span {
        background: var(--darker-blue);
      }
    }
  }
}
</style>